import BaseComponent from "./BaseComponent";
import PatternsData from "../model/PatternsData";
import Entity from "../components/Entity";
import C_Entity from "../../const/C_Entity";
import C_Physics from "../../const/C_Physics";
import Physics from "./Physics";
import GameSprite from "./GameSprite";
import FlierLogic from "./FlierLogic";
import FlierData from "../model/FlierData";
import C_FormationType from "../../const/C_FormationType";


class FormationSpawner extends BaseComponent
{
    constructor(type)
    {
        // type = 1;
        super();

        this.formType = type;
        this.formData = PatternsData.byType[type];
        this.wavesData = this.formData.waves;
        this.currentWave = 1;
        this.wavesToSpawn = Object.keys(this.wavesData).length;

        this.timeToNext = this.wavesData[this.currentWave].spawnDelay;

        this.isEven = true;
    }


    update(delta)
    {
        this.timeToNext -= delta;

        if (this.timeToNext <= 0)
        {
            let wave = this.wavesData[this.currentWave];

            for (let i = 0; i < wave.fliers.length; i++)
            {
                this.spawn(wave.fliers[i]);
            }

            if (this.currentWave == this.wavesToSpawn) // restart waves, should switch between Odd/Even
            {
                this.isEven = !this.isEven;
                this.currentWave = 1;
            }
            else
            {
                this.currentWave++;
            }

            this.timeToNext = this.wavesData[this.currentWave].spawnDelay;
        }
    }


    spawn(flier)
    {
        let flierData = FlierData.byType[flier.shipId];
        let waveSize = flierData.size;
        let position;
        if (flier.positionOdd)
        {
            position = this.isEven ? flier.positionEven : flier.positionOdd;
        }
        else
        {
            position = flier.position;
        }

        let e = new Entity(C_Entity.FLIER);

        let p = new Physics();
        p.setSpriteRendered(false);
        p.setPosition(position.x, position.y, position.z);
        p.setVelocity(flier.velocity.x, flier.velocity.y, -flier.velocity.z);
        p.setSize(waveSize);
        p.initPhysics(C_Physics.PASSIVE, waveSize * .5);
        p.setPositionLimits(flierData.posMin, flierData.posMax);

        let shipTextName = "ship_" + flier.shipId;
        let s = new GameSprite(shipTextName);
        s.sprite.interactive = true;
        s.sprite.flierId = e.getId();
        s.setTarget();
        s.fadeInTime = .5;

        if (flierData.animation)
        {
            s.addAnimationSprite(flierData.endFrame, flierData.animationHeight, flierData.animAnchor);
        }
        if (flierData.overlay)
        {
            s.addBlinkOverlay(1);
        }

        if (this.formType == C_FormationType.RESCUE_MISSION)
        {
            s.addAlienGoo();
        }

        let waveData = this.wavesData[this.currentWave];
        if (waveData.permanentRotation)
        {
            let rotSpeed = -.01 + Math.random() * .02;
            p.setZTriggeredRotation(rotSpeed, Number.POSITIVE_INFINITY);
        }
        else if (waveData.rotationSpeed)
        {
            p.setZTriggeredRotation(waveData.rotationSpeed, waveData.zTriggerRotation);
        }
        else if (waveData.waveCircle)
        {
            p.addVelocityModifier(waveData.circleDetails.x, waveData.circleDetails.y, waveData.circleDetails.z)
        }
        else if (waveData.waveVertical)
        {
            let details = waveData.verticalDetails;
            p.addVelocityModifier(details.x, details.y, details.z);
        }

        let l = new FlierLogic(flier.shipId);
        l.shipType = flierData.shipType;

        // if (Math.random() < flierData.shootChance)
        // {
        //     l.isShooter = true;
        // }


        e.addComponent(p);
        e.addComponent(s);
        e.addComponent(l);

        this.entitySystem.addEntity(e);
    }
}

export default FormationSpawner;